module.exports = __webpack_public_path__ + "static/assets/e22c439bac2069da4d0af8eb46317743.png";